import {useEffect} from 'react';
import {Formik} from 'formik';
import {Button} from '../common/Button';
import {AddOperatoryProps} from '../../constants/types';
import permissionsInfo from '../../constants/permissionsInfo';
import EnsurePermission from '../common/EnsurePermission';
import {operatoryValidationSchema} from '../../constants/validationSchemes';
import Spinner from '../common/Spinner';
import useOnUnsavedChanges from '../../hooks/useOnUnsavedChanges';
import {TextField} from '../common/formik/fields';
import {FormGroup} from '@mui/material';

const initialValues: AddOperatoryProps = {
  desc: '',
  number: ''
};

type AddOperatoryComponentProps = {
  toggleAddForm: boolean,
  handleAddOperatory: (
    values: AddOperatoryProps,
    resetForm: () => void
  ) => Promise<void>;
  clearErrors: () => void;
  apiValidationError: Nullable<Dictionary<string[]>>
}

const AddOperatory = ({
  handleAddOperatory, apiValidationError, clearErrors, toggleAddForm
}: AddOperatoryComponentProps) => {
  return (
    <EnsurePermission elementPermissions={permissionsInfo.operatories.create}>
      <Formik
        initialValues={initialValues}
        validationSchema={operatoryValidationSchema}
        validateOnBlur={false}
        onSubmit={async (values, {resetForm}) => {
          await handleAddOperatory(values, resetForm);
        }}
      >
        {({setFieldTouched, submitForm, resetForm,
          errors, values, isSubmitting, isValid, dirty}) => {
          useOnUnsavedChanges(dirty);

          useEffect(() => {
            resetForm({values, errors, touched: {}});
          }, [toggleAddForm]);

          return (
            <tr className="table-form-row">
              <td className="cell form-cell">
                <FormGroup>
                  <TextField
                    size="small"
                    id="desc"
                    name="desc"
                    placeholder="Description"
                    required
                    apiValidationError={apiValidationError}
                    onBlur={() => {
                      setFieldTouched('desc', true);
                    }}
                    onFocus={() => clearErrors()}
                  />
                </FormGroup>
              </td>

              <td className="cell form-cell">
                <FormGroup>
                  <TextField
                    size="small"
                    id="number"
                    name="number"
                    placeholder="Operatory #"
                    required
                    apiValidationError={apiValidationError}
                    onBlur={() => {
                      setFieldTouched('number', true);
                    }}
                    onFocus={() => clearErrors()}
                  />
                </FormGroup>
              </td>

              <td className="cell form-cell narrow-cell">
                <Button testId="create-operation"
                  disabled={isSubmitting || !isValid}
                  type="submit"
                  label="Add record"
                  variant="contained"
                  onClick={() => submitForm()}>
                  {isSubmitting ? <Spinner embedded /> : null}
                </Button>
              </td>
            </tr>);
        }}
      </Formik>
    </EnsurePermission>
  );
};

export default AddOperatory;
